import React, { useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { isNonEmptyString, isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";

import { useDictionary, useFormAccesses } from "hooks";
import { COLUMN_HEADER_KEYS } from "globals/constants";
import { proposalSelectors } from "store/selectors";
import { getProposal } from "store/actions/proposal";
import FormHistoryView from "components/FormHistoryView";

const ProposalHistoryView = () => {
	const proposal = useSelector(proposalSelectors.proposal);
	const formAccesses = useFormAccesses(COLUMN_HEADER_KEYS.PROPOSAL, proposal.proposalId);
	const dictionary = useDictionary("proposals.history");

	const updateProposalSelection = proposal => {
		const selections = new Map();
		const proposalFeedItem = {
			id: proposal.id,
			proposalId: proposal.proposalId,
			adminTeamMemberData: proposal.adminTeamMembers,
			adminTeamMembers: isNonEmptyArray(proposal.adminTeamMembers)
				? proposal.adminTeamMembers.map(member => member.fullName).join(", ")
				: ""
		};
		selections.set(proposal.id, proposalFeedItem);

		return selections;
	};

	const refreshProposal = useCallback(() => {
		getProposal(proposal.proposalId, { isRefresh: true });
	}, [ proposal ]);

	useEffect(() => {
		if (isNonEmptyString(proposal.proposalId)) {
			getProposal(proposal.proposalId);
		}
	}, [ proposal.proposalId ]);

	return (
		<FormHistoryView
			instance={proposal}
			refreshInstance={refreshProposal}
			dictionary={dictionary}
			updateInstanceSelection={updateProposalSelection}
			canReadNotes={formAccesses.review}
			canAssign={formAccesses.updateAdminTeam}
			adminRole={"SP Proposal Administrator"}
			formType={COLUMN_HEADER_KEYS.PROPOSAL}
			formIdKey="proposalId"
		/>
	);
};

export default ProposalHistoryView;
